var React = require('react');

function IconServices (props) {
    return React.createElement("svg",props,React.createElement("path",{"d":"M762.963 459.26L1000 592.592v274.074L762.963 1000 525.926 866.667V592.593l237.037-133.334zm-525.926 0l237.037 133.333v274.074L237.037 1000 0 866.667V592.593l237.037-133.334zm525.926 72.684L588.426 632.64v201.389l174.537 100.694L937.5 834.028v-201.39L762.963 531.945zm-525.926 0L62.5 632.64v201.389l174.537 100.694 174.537-100.694v-201.39L237.037 531.945zM496.297 0l237.036 133.333v274.074L496.296 540.741 259.26 407.407V133.333L496.296 0zm0 72.685L321.758 173.38v201.389l174.537 100.694 174.537-100.694v-201.39L496.296 72.686z","fill":"currentColor","fillRule":"nonzero"}));
}

IconServices.defaultProps = {"width":"1000","height":"1000","viewBox":"0 0 1000 1000"};

module.exports = IconServices;

IconServices.default = IconServices;
